module.exports = __webpack_public_path__ + "img/published-modal-image.a8f61ea7.png";